import React from 'react';
import { appstore_svg, googleplay_svg, rustore_svg, school_svg, school_svg_green } from '../Svg/svgs';

import './Products.css'

// Пример: эти SVG можно импортировать или вставить как JSX
// import { ReactComponent as SchoolIcon } from './icons/school.svg';
// const school_svg = <SchoolIcon />;
// const appstore_svg = <AppstoreIcon />;
// const googleplay_svg = <GooglePlayIcon />;
// const rustore_svg = <RuStoreIcon />;

const Products = () => {
  return (
    <div style={styles.container}>
      <div className='product-card'>
        
        <a href="https://gd-lab.zenclass.ru/public/school" target="_blank" rel="noopener noreferrer">
          {school_svg_green}
        </a>
      </div>

      <div className='product-card'>
        <a href="https://apps.apple.com/ru/app/dent-app/id6742460387" target="_blank" rel="noopener noreferrer">
          {appstore_svg}
        </a>
      </div>

      <div className='product-card'>
        {googleplay_svg}
      </div>

      <div className='product-card'>
        {rustore_svg}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    gap: '20px',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    padding: '20px',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: '10px',
    padding: '10px',
    borderRadius: '8px',
    minWidth: '120px',
    backgroundColor: 'var(--davys-gray)',
    height: '50px',
    border: '1px solid var(--verdigris)'
  },
};

export default Products;
